<script setup lang="ts">
import { EARNING_STEP_1_EVENT } from '~/utils/analytics/earnings'

interface Props {
  idForm: string
  onStepSuccess: () => Promise<void>
}

const { t } = useI18n()

const props = defineProps<Props>()

const { params } = storeToRefs(useEarningsStore())

const options = [
  {
    text: t('pages.earnings.owner.own_vehicle'),
    value: 1,
  },
  {
    text: t('pages.earnings.owner.planned_delivery'),
    value: 2,
  },
  {
    text: t('pages.earnings.owner.thinking_about_it'),
    value: 3,
  },
]

const submitAction = () => {
  const { event } = useGtag()
  event(EARNING_STEP_1_EVENT)
  props.onStepSuccess()
  return Promise.resolve()
}
</script>

<template>
  <div>
    <YscForm
      :id="props.idForm"
      :submit-action="submitAction"
    >
      <div class="mb-6 md:mb-8">
        <h2 class="text-xl font-semibold mb-4">
          {{ $t('pages.earnings.owner.title') }}
        </h2>
        <p>{{ $t('pages.earnings.owner.subtitle') }}</p>
      </div>

      <YscInputRadioGroup
        id="availability"
        v-model.number="params.vehicle_availability"
        :options="options"
        name="availability"
        layout-column
        required
      />
    </YscForm>
  </div>
</template>
